export default "__VITE_ASSET__f5c93e7b__"